import usePrevious from './usePrevious';

function useCompare<T>(val: T): boolean {
  const prevVal = usePrevious<T>(val);
  return prevVal !== val;
}

export default useCompare;
